import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from 'components/ui/modal';
import Form from 'components/form';
import Input from 'components/form/Input';
import DropZone from 'components/form/Dropzone';
import Button from 'components/common/Button';
import Spin from 'components/common/Spin';
import useSnack from 'hooks/useSnack';
import { API, Storage } from 'aws-amplify';
import { useMutation } from 'react-apollo';
import { ADD_DOCUMENT } from 'graphql/student/essays';
import axios from "axios";

const FormItem = Form.FormItem;

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 360,
    [theme.breakpoints.down('sm')]: {
      minWidth: 30,
    },
  },
  input: {
    marginBottom: theme.spacing(3),
  },
}));

const UploadModal = ({ onClose, onSubmit, form, user }) => {
  const classes = useStyles();
  const snack = useSnack();
  const [addDocument] = useMutation(ADD_DOCUMENT);
  const [uploadProgress, setUploadProgress] = useState(0);
  const cancelToken = useRef(axios.CancelToken.source());

  const { getFieldDecorator, validateFields, getFieldValue, setFieldsValue } = form;

  const onCancel = () => {
    cancelToken.current.cancel();
    onClose();
  }

  const handleSubmit = () => {
    return validateFields().then(async (values) => {
      const { filename, files } = values;
      const file = files[0].file;

      const resp = await API.post('api', '/files/signed_url', {
        body: {
          contentType: file.type,
          filename: file.name,
        },
      });

      await axios.put(resp.url, file, {
        onUploadProgress: (e) => {
          const pcDone = Math.round(e.loaded * 100 / e.total);
          setUploadProgress(pcDone);
        },
        cancelToken: cancelToken.current.token,
      });

      onSubmit({
        filename,
        original_name: file.name,
        object_key: resp.key,
      });
    });
  };

  return (
    <Modal
      open
      fullWidth
      title="Upload file"
      size="md"
      actions={[
        <Button variant="text" onClick={onCancel}>
          Cancel
        </Button>,
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Upload file
        </Button>,
      ]}
    >
      <Spin spinning={uploadProgress} tip={`Uploading.. ${uploadProgress}%`}>
        <div className={classes.root}>
          <FormItem>
            {getFieldDecorator('filename', {
              initialValue: '',
              rules: [{ required: true }],
            })(<Input placeholder="Enter file name here" label="File name" />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('files', {
              rules: [{ required: true }],
            })(
              <DropZone
                accept=".doc,.docx,.pdf,.xls,.xlsx,image/*"
              />
            )}
          </FormItem>
        </div>
      </Spin>
    </Modal>
  );
};

export default Form.create()(UploadModal);
